import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const whatsappTemplateApi = createApi({
    reducerPath: 'whatsappTemplateApi',
    tagTypes: ['whatsappTemplates'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        editTemplate: build.mutation({
            query: (data) => ({
                url: api.notificationTemplates.createTemplate(),
                method: 'POST',
                body: data
            }),
        }),
        showTemplate: build.query({
            query: ({template, ...data}) => ({
                url: api.notificationTemplates.getTemplate(template),
                method: 'GET',
                params: data
            }),
        })
    })
})

export const {useLazyShowTemplateQuery} = whatsappTemplateApi
